import reqEnum from '../../utils/request-statuses';

export const isLoggedIn = state => state.auth.loggedIn;
export const getProfile = state => state.auth.profile;
export const authStatus = state => state.auth.status;
export const authLoadingInProgress = state => state.auth.status === reqEnum.loading;
export const authLoadingFailed = state => state.auth.status === reqEnum.rejected;
export const authError = state => state.auth.error;